'use strict';

require('./google_map.js');
var google_map = require('../../../_virtual/google_map.js_commonjs-exports.js');

exports["default"] = undefined;

var _google_map = google_map.__exports;

var _google_map2 = _interopRequireDefault(_google_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _google_map2.default;

module.exports = exports["default"];
